/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';
import _ from 'lodash';
import can from 'can';

const RENDER_AWAITING_INTERVAL = 10;
const RENDER_AWAITING_MAX_CHECKS = 20;

export const EmbedSocial = BaseControl.extend({
    _re: [],

    init: function () {
        this._super();

        const html = this.$element.html();

        if (html.indexOf('<iframe') > -1) {
            this.$element.toggle(false);

            this.awaitRender().then(() => {
                this.processIFrame(html);
                this.$element.toggle(true);
            });
        }
    },

    awaitRender: function () {
        const defer = can.Deferred();
        let checks, awaiter;

        checks = 0;
        awaiter = setInterval(() => {
            const $el = this.$element.find('iframe');

            if ($el.length === 1) {
                clearInterval(awaiter);
                this.$iframe = $el;
                defer.resolve();
            }
            checks++;
            if (checks > RENDER_AWAITING_MAX_CHECKS) {
                clearInterval(awaiter);
                defer.reject();
            }
        }, RENDER_AWAITING_INTERVAL);

        return defer;
    },

    getDim: function (dim, html) {
        const re = (this._re && this._re[dim]) ||
            (this._re[dim] = new RegExp(`<iframe.*?${dim}="([0-9]+)"`, 'i'));
        return [].concat(html.match(re))[1];
    },


    processIFrame: function (html) {
        this._originalWidth = this.getDim('width', html);
        this._originalHeight = this.getDim('height', html);

        if (this._originalWidth) {
            DomEventsManager.subscribe(this);
            this.updateSize();
        }
    },

    updateSize: function () {
        const containerWidth = this.$element.width();

        if (containerWidth >= this._originalWidth) {
            this.$iframe.attr('width', this._originalWidth);

            if (this._originalHeight) {
                this.$iframe.attr('height', this._originalHeight);
            }
        }
        else {
            this.$iframe.attr('width', containerWidth);

            if (this._originalHeight) {
                const offset = containerWidth < this._originalWidth ? 40 : 0; // additional height in order not to cut text
                const aspect = containerWidth / this._originalWidth;

                this.$iframe.attr('height', (this._originalHeight * aspect)  + offset);
            }
        }
    },

    onWindowResize: function () {
        this.updateSize();
    }
});
